/*
 * @Descripttion:
 * @version:
 * @Author: 廖图图
 * @Date: 2021-11-16 09:18:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-06-22 09:13:05
 */
/**
 * 文件资源
 */
const file = {
  pullSmallFile: "/api/pullSmallFile", //拉取小文件
  pushSmallFile: "/api/pushSmallFile", //上传小文件
  getFilesInfo: "/api/getFilesInfo", //获取文件信息
  deleteSmallFile: "/api/deleteSmallFile", //删除文件资源
  pullCompanySmallFile: "/api/pullCompanySmallFile", //拉取公司文件
  pushCompanyFileToOss: "/api/pushCompanyFileToOss", //上传公司文件
  getCompanyFilesInfo: "/api/getCompanyFilesInfo", //获取公司文件信息
  deleteCompanySmallFile: "/api/deleteCompanySmallFile", //删除公司文件资源
  listMeasureDocument: "/api/listMeasureDocument",
  uploadFile: "/api/uploadFile",
  removePhotoForMeasure: "/api/removePhotoForMeasure",
  ossUpload: "/api/file/oss/upload",
};

export default file;
